export function SpadeSvg({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 120" fill="currentColor" aria-hidden="true">
      <path d="M50 10 C50 10 10 50 10 70 C10 90 30 95 50 80 C70 95 90 90 90 70 C90 50 50 10 50 10Z" />
      <rect x="45" y="78" width="10" height="25" rx="3" />
    </svg>
  );
}

export function HeartSvg({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">
      <path d="M50 90 C50 90 10 60 10 35 C10 15 30 10 50 30 C70 10 90 15 90 35 C90 60 50 90 50 90Z" />
    </svg>
  );
}

export function DiamondSvg({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 80 100" fill="currentColor" aria-hidden="true">
      <path d="M40 5 L75 50 L40 95 L5 50Z" />
    </svg>
  );
}

export function ClubSvg({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 120" fill="currentColor" aria-hidden="true">
      <circle cx="50" cy="35" r="22" />
      <circle cx="28" cy="60" r="22" />
      <circle cx="72" cy="60" r="22" />
      <rect x="45" y="70" width="10" height="30" rx="3" />
    </svg>
  );
}

export function LogoutSvg({ width = 18, height = 18 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}

export function BackArrowSvg({ width = 18, height = 18 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

export function ChevronRightSvg({ width = 20, height = 20 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

export function TrophySvg({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 8h28v16c0 8-6 16-14 16S18 32 18 24V8z" fill="rgba(255,215,0,0.15)" />
      <path d="M18 14H8c0 8 4 14 10 14" />
      <path d="M46 14h10c0 8-4 14-10 14" />
      <line x1="32" y1="40" x2="32" y2="50" />
      <rect x="20" y="50" width="24" height="6" rx="2" fill="rgba(255,215,0,0.15)" />
    </svg>
  );
}

export function ChartSvg({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="8" y="32" width="12" height="24" rx="2" fill="rgba(59,130,246,0.15)" />
      <rect x="26" y="16" width="12" height="40" rx="2" fill="rgba(59,130,246,0.25)" />
      <rect x="44" y="24" width="12" height="32" rx="2" fill="rgba(59,130,246,0.15)" />
    </svg>
  );
}

export function GearSvg({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="32" cy="32" r="10" />
      <path d="M32 6v8M32 50v8M6 32h8M50 32h8M13 13l6 6M45 45l6 6M13 51l6-6M45 19l6-6" />
    </svg>
  );
}
